import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject, Component, OnInit } from '@angular/core';

@Component({
  selector: 'xsr-service-selection-dialog',
  templateUrl: 'service-selection-dialog.component.html',
  styleUrls: ['service-selection-dialog.component.css'],
})
export class ServiceSelectionDialogComponent implements OnInit {
  selectedServiceGroup: any;

  constructor(
    public dialogRef: MatDialogRef<ServiceSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    console.log(this.data);
  }

  onCancel(): void {
    this.dialogRef.close({ cancelled: true, selectedServiceGroup: null });
  }

  onConfirm(selectedServiceGroup: any): void {
    this.dialogRef.close({ cancelled: false, selectedServiceGroup: selectedServiceGroup });
  }
}
